<script>
export default {
  functional: true,
  render: (h, { props }) => {
    const { actions } = props
    let actionList = actions.map((action, idx) => {
      const doAction = e => {
        e.preventDefault()
        e.stopPropagation()
        action.callBack()
      }
      return (
        <v-list-tile
          key={idx}
          on-click={ doAction }
        >
          <v-list-tile-action>
            <v-icon>{action.icon}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{action.label}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      )
    })

    return (
      <v-menu offset-y>
        <v-btn icon slot="activator">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          { actionList }
        </v-list>
      </v-menu>
    )
  },
}
</script>
